/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormikErrors } from 'formik';
import moment from 'moment';
import { DATE_FORMAT_DEFAULT } from '../../appConstants';

export const getFormikErrorMessage = (errors : FormikErrors<any>, field : string) : null | string => {
    const propertyPath = field.split('.');

    // Since we are traversing multiple types, it's going to be more pain trying to keep this type safe when it inherently isn't.
    let currentValue : any = errors;

    for (const property of propertyPath) {
        if (!currentValue[property]) return null;
        currentValue = currentValue[property];
    }

    return currentValue;
};

export const getDataGridIsActiveRowColors = (rowId : number, isActive : boolean) : '' | 'bcr' | 'bclr' => {
    if (isActive) return '';

    return rowId % 2 ? 'bcr' : 'bclr';
};

export const uppercase = (value : string) : string => value.toUpperCase();
export const lowercase = (value : string) : string => value.toLowerCase();

export const compareString = (a : string, b : string) : number => {
    if (a === b) {
        return 0;
    }

    if (!a && !b) return 0;
    if (!a && b) return -1;
    if (a && !b) return 1;

    return a < b ? -1 : 1;
};

export const compareNumber = (a : number, b : number) : number => {
    if (a === b) {
        return 0;
    }

    if (!a && !b) return 0;
    if (!a && b) return -1;
    if (a && !b) return 1;

    return a < b ? -1 : 1;
};

export const compareBool = (a : boolean, b : boolean) : number => {
    if (a === b) {
        return 0;
    }
    return b ? -1 : 1;
};

export const compareDate = (a : string, b : string) : number => {
    if (a === b) {
        return 0;
    }

    if (!a && !b) return 0;
    if (!a && b) return -1;
    if (a && !b) return 1;

    let newA = a;
    let timeA;
    let newB = b;
    let timeB;

    if (a.includes(' ')) {
        const temp = a.split(' ');
        if (temp[0].includes('/')) {
            newA = temp[0];
            timeA = temp[1];
        } else {
            newA = temp[1];
            timeA = temp[0];
        }
    }

    if (b.includes(' ')) {
        const temp = b.split(' ');
        if (temp[0].includes('/')) {
            newB = temp[0];
            timeB = temp[1];
        } else {
            newB = temp[1];
            timeB = temp[0];
        }
    }

    const dayA = newA.split('/')[0];
    const dayB = newB.split('/')[0];
    const monthA = newA.split('/')[1];
    const monthB = newB.split('/')[1];
    const yearA = newA.split('/')[2];
    const yearB = newB.split('/')[2];

    if (yearA === yearB) {
        if (monthA === monthB) {
            if (dayA === dayB) {
                if (timeA && timeB) {
                    if (timeA === timeB) {
                        return 0;
                    }
                    return timeA < timeB ? -1 : 1;
                }
                return 0;
            }
            return dayA < dayB ? -1 : 1;
        }
        return monthA < monthB ? -1 : 1;
    }
    return yearA < yearB ? -1 : 1;
};

export function formatDateTime(dateTime : string | number) : string {
    return dateTime ? moment.utc(dateTime).local().format(DATE_FORMAT_DEFAULT) : '';
}

export const addkg = (value ?: number | string | null) : string => (value === undefined || value === null) ? '' : value + ' kg';
export const addea = (value ?: number | string | null) : string => (value === undefined || value === null) ? '' : value + ' ea';

export const booleanToYesNo = (val : boolean) : 'Yes' | 'No' | 'No Data' => {
    switch (val) {
        case true:
            return 'Yes';
        case false:
            return 'No';
        default:
            return 'No Data';
    }
};

export const handleDateRangeChange = (
    start : moment.Moment, 
    end : moment.Moment, 
    setfromDateCallback : (value : React.SetStateAction<moment.Moment>) => void,
    setToDateCallback : (value : React.SetStateAction<moment.Moment>) => void,
    changedBy ?: 'start' | 'end',
) : void => {

    const fromDate = changedBy === 'start' ?
        moment(start).startOf('day')
        : end < start ?
            moment(end).startOf('day')
            : moment(start).startOf('day');

    const toDate = changedBy === 'end' ?
        moment(end).endOf('day')
        : start > end ?
            moment(start).endOf('day')
            : moment(end).endOf('day');

    setfromDateCallback(fromDate);
    setToDateCallback(toDate);
};